import { useLiveQuery } from "dexie-react-hooks"

import type { LiveQueryResult } from "../../types"
import {
  type ClaimDetailLocal,
  getClaimDetailsByMarker,
  getPendingClaimDetailDeletions,
  getPendingClaimDetailsForUpload,
} from "./claimDetails"

export function useClaimDetailsByMarker(markerId: string): LiveQueryResult<ClaimDetailLocal[]> {
  return useLiveQuery(async () => ({ data: await getClaimDetailsByMarker(markerId), isLoading: false }), [markerId], {
    data: undefined,
    isLoading: true,
  })
}

export function usePendingClaimDetailsForUpload(sessionId: string): LiveQueryResult<ClaimDetailLocal[]> {
  return useLiveQuery(
    async () => ({ data: await getPendingClaimDetailsForUpload(sessionId), isLoading: false }),
    [sessionId],
    {
      data: undefined,
      isLoading: true,
    },
  )
}

export function usePendingClaimDetailDeletions(sessionId: string): LiveQueryResult<ClaimDetailLocal[]> {
  return useLiveQuery(
    async () => ({ data: await getPendingClaimDetailDeletions(sessionId), isLoading: false }),
    [sessionId],
    {
      data: undefined,
      isLoading: true,
    },
  )
}
